export const useAnyHelper = (filters: { [key: string]: unknown[] }) => {
    let filterResult = '';

    for (const key in filters) {
        if (filters[key].length > 0) {
            filterResult += '&filter=' + key + ':' + filters[key].map((filter: unknown) => filter).join('');
        }
    }

    return { filterResult, filters };
};
